"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSocket = exports.SocketProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const socket_events_1 = require("@src/types/socket-events");
const types_1 = require("@src/types");
const NotificationImageOrIcon_1 = require("@src/components/modules/global/NotificationImageOrIcon");
const get_cdn_image_url_for_account_type_1 = require("@src/helpers/get-cdn-image-url-for-account-type");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const socket_1 = require("../socket");
const SocketContext = react_1.default.createContext(socket_1.socket);
const SocketProvider = props => {
    const intl = (0, react_intl_1.useIntl)();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    function displayCompanySubscriptionNotification(receivedNotification) {
        const context = JSON.parse(receivedNotification.context);
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: (0, jsx_runtime_1.jsx)("strong", { children: context.offerTitle }),
            description: intl.formatMessage({ id: 'global.notification.new_company_offer.popup' }, { companyName: context.companyName, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayOfferSubscriptionNotification(receivedNotification) {
        const context = JSON.parse(receivedNotification.context);
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: (0, jsx_runtime_1.jsx)("strong", { children: context.offerTitle }),
            description: intl.formatMessage({ id: 'global.notification.new_subscription_offer' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayNewCompanySubscriberNotification(receivedNotification) {
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'global.notification.new_company_subscriber.title' }),
            description: intl.formatMessage({ id: 'global.notification.new_company_subscriber.content' }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayNewHiringProcessResultNotification(receivedNotification) {
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'global.notification.hiring_process_result.title' }),
            description: intl.formatMessage({ id: 'global.notification.hiring_process_result.content' }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayNewHiringProcessClosedNotification(receivedNotification) {
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'global.notification.hiring_process_result.title' }),
            description: intl.formatMessage({ id: 'global.notification.hiring_process_closed.content' }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayNewOfferApplicationNotification(receivedNotification) {
        const context = JSON.parse(receivedNotification.context);
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: (0, jsx_runtime_1.jsx)("strong", { children: context.offerTitle }),
            description: intl.formatMessage({ id: 'global.notification.new_offer_application.popup' }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayCompanyViewedProfileNotification(receivedNotification) {
        const context = JSON.parse(receivedNotification.context);
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: (0, jsx_runtime_1.jsx)("strong", { children: context.companyName }),
            description: intl.formatMessage({ id: 'global.notification.candidate_progress.viewed.content' }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayNewCreditsExpirationNotification(receivedNotification) {
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'global.notification.credits_expiration.title' }),
            description: intl.formatMessage({ id: 'global.notification.credits_expiration.content' }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayCandidateNewInterviewNotification(receivedNotification) {
        const context = JSON.parse(receivedNotification.context);
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'global.notification.candidate_progress.interview.title' }),
            description: intl.formatMessage({ id: 'global.notification.candidate_progress.interview' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayCreditsPaidNotification(receivedNotification) {
        const context = JSON.parse(receivedNotification.context);
        const notificationSenderAccountType = types_1.NotificationSenderAccountTypeMap[receivedNotification.notification_type_id];
        const imageUrl = (0, get_cdn_image_url_for_account_type_1.getCdnImageUrlForAccountType)(receivedNotification.image, notificationSenderAccountType, 'c_scale,w_30');
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'global.notification.paid_credits.title' }),
            description: intl.formatMessage({ id: 'global.notification.paid_credits.description' }, { ...context, strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }) }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: imageUrl })),
            duration: 10,
        });
    }
    function displayCompanyOfferDeadlineNotification(receivedNotification) {
        const context = JSON.parse(receivedNotification.context);
        antd_1.notification.success({
            message: intl.formatMessage({ id: 'global.notification.offer_deadline.popup' }),
            description: (0, jsx_runtime_1.jsx)("strong", { children: context.offerTitles }),
            icon: ((0, jsx_runtime_1.jsx)(NotificationImageOrIcon_1.NotificationImageOrIcon, { notificationType: receivedNotification.notification_type_id, imageUrl: receivedNotification.image })),
            duration: 10,
        });
    }
    function handleNotificationReceived(receivedNotification) {
        switch (receivedNotification.notification_type_id) {
            case types_1.NotificationType.COMPANY_SUBSCRIPTION_NOTIFICATION:
                displayCompanySubscriptionNotification(receivedNotification);
                break;
            case types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION:
                displayOfferSubscriptionNotification(receivedNotification);
                break;
            case types_1.NotificationType.NEW_COMPANY_SUBSCRIBER_NOTIFICATION:
                displayNewCompanySubscriberNotification(receivedNotification);
                break;
            case types_1.NotificationType.HIRING_PROCESS_RESULT_NOTIFICATION:
                displayNewHiringProcessResultNotification(receivedNotification);
                break;
            case types_1.NotificationType.HIRING_PROCESS_CLOSED_NOTIFICATION:
                displayNewHiringProcessClosedNotification(receivedNotification);
                break;
            case types_1.NotificationType.NEW_OFFER_APPLICATION_NOTIFICATION:
                displayNewOfferApplicationNotification(receivedNotification);
                break;
            case types_1.NotificationType.CREDITS_EXPIRATION_NOTIFICATION:
                displayNewCreditsExpirationNotification(receivedNotification);
                break;
            case types_1.NotificationType.NEW_CANDIDATE_INTERVIEW_NOTIFICATION:
                displayCandidateNewInterviewNotification(receivedNotification);
                break;
            case types_1.NotificationType.COMPANY_VIEWED_RESUME_NOTIFICATION:
                displayCompanyViewedProfileNotification(receivedNotification);
                break;
            case types_1.NotificationType.CREDITS_PAID_NOTIFICATION:
                displayCreditsPaidNotification(receivedNotification);
                break;
            case types_1.NotificationType.COMPANY_OFFER_DEADLINE_NOTIFICATION:
                displayCompanyOfferDeadlineNotification(receivedNotification);
                break;
            default:
                throw new Error('Unknown notification type');
        }
    }
    react_1.default.useEffect(() => {
        socket_1.socket.on(socket_events_1.SocketEvents.ACCOUNT_AUTHENTICATED, () => {
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
        });
        socket_1.socket.on(socket_events_1.SocketEvents.ACCOUNT_LOG_OUT, () => {
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
        });
        socket_1.socket.on(socket_events_1.SocketEvents.ACCOUNT_VERIFIED, () => {
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
        });
        socket_1.socket.on(socket_events_1.SocketEvents.ACCOUNT_REGISTERED, () => {
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
        });
        socket_1.socket.on(socket_events_1.SocketEvents.NOTIFICATION_RECEIVED, handleNotificationReceived);
    }, []);
    return (0, jsx_runtime_1.jsx)(SocketContext.Provider, { value: socket_1.socket, children: props.children });
};
exports.SocketProvider = SocketProvider;
const useSocket = () => {
    const context = react_1.default.useContext(SocketContext);
    return context;
};
exports.useSocket = useSocket;
